import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eba4b288"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无消息", -1))

import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'message',
  setup(__props) {

const drawer = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_Message = _resolveComponent("Message", true)!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_badge, {
      "is-dot": "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = true))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          size: "small",
          type: "info",
          circle: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { size: 13 }, {
              default: _withCtx(() => [
                _createVNode(_component_Message)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_drawer, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
      size: "300",
      title: "消息列表"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})